

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const GETALLEMPLOYEEBYID= createAsyncThunk(
  "getEmployeeById/getEmployeeById",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getEmployeeByIdSlice = createSlice({
  name: "getEmployeeByIdSlice",
  initialState: {
    getEmployeeById: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetEmployeeById: (state) => {
        state.getEmployeeById.loading = false
        state.getEmployeeById.error = false
        state.getEmployeeById.data = []
        state.getEmployeeById.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETALLEMPLOYEEBYID.fulfilled, (state, action) => {
      state.getEmployeeById = {
        ...state.getEmployeeById,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLEMPLOYEEBYID.pending, (state, action) => {
      state.getEmployeeById = {
        ...state.getEmployeeById,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLEMPLOYEEBYID.rejected, (state, action) => {
      state.getEmployeeById = {
        ...state.getEmployeeById,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getEmployeeByIdAction = {
    GETALLEMPLOYEEBYID,
};

export { getEmployeeByIdAction };
export default getEmployeeByIdSlice.reducer;
export const {setInitialStateOfgetEmployeeById} = getEmployeeByIdSlice.actions
